import { LazyViewDownloadStrategy } from './lazy-view-download-strategy.service';

/**
 * This load strategy does nothing. It allows the module to be loaded immediately.
 */
export class NoopDownloadStrategyService implements LazyViewDownloadStrategy {

    public async shouldLoad(): Promise<void> {
        return;
    }
}
